module.exports = __webpack_public_path__ + "static/img/melbourne.41a3433.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/melbourne.jpg
// module id = SGNz
// module chunks = 1